import cn from 'clsx';

export const SingleProductFocusInStockIndicator = ({product}) => {
  let preorderInfo = product?.pre_order_info ?? product?.preorderInfo;
  let isInStock = product?.isInStock === true ?? product?.currentlyInStock === true;

  let isPreOrderEnabled = preorderInfo?.is_pre_order_enabled;
  let isPreOrderEligible = preorderInfo?.is_pre_order_eligible;
  let isPreorder = !isInStock && isPreOrderEnabled && isPreOrderEligible;

  let totalQtyWithoutFba = product?.inventory?.total_qty_without_fba;
  // console.log({product, totalQtyWithoutFba})

  if (isPreorder) {
    return (
      <div className={cn('flex items-center gap-2 font-bold text-sky-700 lg:pt-4')}>
        <div
          className={
            'w-3 h-3 bg-sky-700 rounded-full shadow-[0px_0px_5px_1px_rgba(3,105,161,0.7)]'
          }></div>
        Pre-Order
      </div>
    );
  }

  if (isInStock || totalQtyWithoutFba > 0) {
    return (
      <div className={cn('flex items-center gap-2 font-bold text-skar-green mt-4 text-sm')}>
        <div
          className={
            'w-2 h-2 bg-skar-green rounded-full shadow-[0px_0px_5px_1px_rgba(32,136,49,0.7)]'
          }></div>
        In Stock
      </div>
    );
  }

  if (!isInStock) {
    return (
      <div className={cn('flex items-center gap-2 font-bold lg:pt-4')}
           style={{color: 'rgba(4,43,138, 1)'}}>
        <div
          className={
            'w-3 h-3 bg-skar-red-dark rounded-full shadow-[0px_0px_5px_1px_rgba(184,3,28,0.7)]'
          }></div>
        Sold Out
      </div>
    );
  }

  return null;
};
